import { G_variables } from "../../utils/globals/variables";
import getVariableData from "./utils/get-variable-data";
import replaceVariables from "./utils/replace-variables";

/**
 * Find and replace variables in a string
 * @param {MainClassProps} main
 * @param {Array<String>} input
 */
const processVariables = (main, input) => {
  /** Rest of attributes that are not variables */
  const attributes = [];

  /** Variables store */
  const store = new Map();

  for (const variable of input) {
    switch (true) {
      /** Global variable */
      case /^\$\$/.test(variable):
        getVariableData(variable, store, G_variables, main, true);
        break;

      /** Local variable */
      case /^\$/.test(variable):
        getVariableData(variable, store, main.variables, main, false);
        break;

      /** No variable */
      default:
        attributes.push(variable);
        break;
    }
  }

  return replaceVariables(attributes, store, main);
};

export default processVariables;
